import { Link } from 'react-router-dom';

const CTASection = () => {
  return (
    <section className="py-32 bg-gradient-to-b from-slate-800/30 to-slate-900/30 relative overflow-hidden">
      {/* 精致背景装饰 */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-20 left-1/4 w-96 h-96 bg-blue-600/5 rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-1/4 w-80 h-80 bg-cyan-600/5 rounded-full blur-3xl"></div>
      </div>

      <div className="relative container mx-auto px-8">
        <div className="max-w-7xl mx-auto">
          <div className="relative group">
            <div className="absolute inset-0 bg-gradient-to-r from-blue-600/10 via-cyan-600/10 to-blue-600/10 rounded-3xl blur-2xl group-hover:blur-3xl transition-all duration-500"></div>
            <div className="relative bg-gradient-to-r from-blue-900/20 via-slate-900/20 to-cyan-900/20 rounded-3xl backdrop-blur-md border border-white/20 hover:border-blue-400/40 transition-all duration-500 overflow-hidden">
              <div className="grid lg:grid-cols-2 gap-16 items-center p-16">
                <div className="space-y-8">
                  <div className="inline-block mb-4">
                    <span className="px-4 py-2 bg-blue-600/20 text-blue-300 rounded-full text-sm font-medium border border-blue-400/30">
                      Ready to Start?
                    </span>
                  </div>
                  
                  <h2 className="text-4xl md:text-5xl font-light text-white leading-tight">
                    Ready to Transform Your <strong className="bg-gradient-to-r from-blue-400 to-cyan-400 bg-clip-text text-transparent">Technology Vision</strong>?
                  </h2>
                  
                  <div className="space-y-6 text-lg font-light leading-relaxed">
                    <p className="text-white/90">
                      From our strategic hub in Hong Kong, Sentronics is committed to being your trusted, agile partner in innovation. We provide the technical expertise and global network to help you harness the power of technology for future success.
                    </p>
                    <p className="text-white/80">
                      Whether you're looking to source breakthrough technologies, develop custom solutions, or expand into new markets, our team is ready to guide you through every step of your innovation journey.
                    </p>
                  </div>
                  
                  <div className="flex flex-col sm:flex-row gap-6 pt-4">
                    <Link
                      to="/contact"
                      className="group/btn relative overflow-hidden px-8 py-4 bg-gradient-to-r from-blue-600 to-cyan-600 hover:from-blue-700 hover:to-cyan-700 text-white rounded-xl transition-all duration-300 font-medium whitespace-nowrap cursor-pointer shadow-lg shadow-blue-600/25"
                    >
                      <span className="relative z-10 flex items-center justify-center">
                        Start Your Project
                        <i className="ri-arrow-right-line ml-2 group-hover/btn:translate-x-1 transition-transform duration-300"></i>
                      </span>
                      <div className="absolute inset-0 bg-gradient-to-r from-white/10 to-transparent opacity-0 group-hover/btn:opacity-100 transition-opacity duration-300"></div>
                    </Link>
                    <Link
                      to="/services"
                      className="px-8 py-4 border-2 border-white/30 hover:border-cyan-400/50 text-white hover:bg-white/10 hover:text-cyan-100 rounded-xl transition-all duration-300 font-medium whitespace-nowrap cursor-pointer backdrop-blur-sm"
                    >
                      Explore Services
                    </Link>
                  </div>
                </div>
                
                <div className="relative">
                  <div className="relative group/img">
                    <div className="absolute inset-0 bg-gradient-to-r from-blue-600/20 to-cyan-600/20 rounded-3xl blur-2xl group-hover/img:blur-3xl transition-all duration-500"></div>
                    <div className="relative overflow-hidden rounded-3xl border border-white/20 group-hover/img:border-blue-400/40 transition-all duration-500">
                      <img 
                        alt="Technology Partnership Success" 
                        className="w-full h-[500px] object-cover transition-transform duration-700 group-hover/img:scale-110" 
                        src="https://public.readdy.ai/ai/img_res/ac32ce38536d504f3fede1c3e11e60d2.jpg"
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
                      <div className="absolute inset-0 bg-gradient-to-r from-blue-600/10 to-transparent opacity-0 group-hover/img:opacity-100 transition-opacity duration-500"></div>
                    </div>
                  </div>
                  
                  {/* 精致的浮动统计卡片 */}
                  <div className="absolute top-8 left-8 group/stat">
                    <div className="relative">
                      <div className="absolute inset-0 bg-blue-600/20 rounded-2xl blur-lg group-hover/stat:blur-xl transition-all duration-300"></div>
                      <div className="relative bg-white/15 backdrop-blur-md rounded-2xl p-6 border border-white/30 group-hover/stat:border-blue-400/50 transition-all duration-300">
                        <div className="text-3xl font-bold bg-gradient-to-r from-blue-400 to-cyan-400 bg-clip-text text-transparent mb-2">15+</div>
                        <div className="text-white text-sm font-medium">Years Experience</div>
                      </div>
                    </div>
                  </div>
                  
                  <div className="absolute bottom-8 right-8 group/stat">
                    <div className="relative">
                      <div className="absolute inset-0 bg-cyan-600/20 rounded-2xl blur-lg group-hover/stat:blur-xl transition-all duration-300"></div>
                      <div className="relative bg-white/15 backdrop-blur-md rounded-2xl p-6 border border-white/30 group-hover/stat:border-cyan-400/50 transition-all duration-300">
                        <div className="text-3xl font-bold bg-gradient-to-r from-cyan-400 to-blue-400 bg-clip-text text-transparent mb-2">200+</div>
                        <div className="text-white text-sm font-medium">Projects Delivered</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
